export default __webpack_public_path__ + "static/media/SELLOS_05.9f645bf2.png";